import {
  TraceAgentNameSchema,
  type TracePreviewDto,
} from '@terra/shared-contracts-trace';

type TraceActionTarget = Pick<
  TracePreviewDto,
  'name' | 'status' | 'signalId' | 'executionId'
>;

export const TRACE_TERMINAL_STATUSES: ReadonlySet<string> = new Set([
  'COMPLETED',
  'FAILED',
  'ABORTED',
  'BLOCKED',
]);

export const isDeepActiveProbeTrace = (trace: Pick<TracePreviewDto, 'name'>) =>
  trace.name === TraceAgentNameSchema.enum.deep_active_probe;

const hasExecution = (trace: TraceActionTarget) => Boolean(trace.executionId);

export const canResumeTrace = (trace: TraceActionTarget) =>
  isDeepActiveProbeTrace(trace)
    ? trace.status === 'ABORTED' && hasExecution(trace)
    : trace.status === 'ABORTED' || trace.status === 'PAUSED';

export const canRerunTrace = (trace: TraceActionTarget) =>
  TRACE_TERMINAL_STATUSES.has(trace.status) &&
  (isDeepActiveProbeTrace(trace)
    ? hasExecution(trace)
    : Boolean(trace.signalId));

export const canAbortTrace = (trace: TraceActionTarget) =>
  trace.status === 'RUNNING' &&
  (!isDeepActiveProbeTrace(trace) || hasExecution(trace));
